import styled from "styled-components";

export const ApplianceCategoryTableStyle = styled.div`

`;
